import { useState, useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import FieldEditor from "@/admin/FieldEditor";
import { HIDDEN_FIELDS } from "@/admin/config";

export default function Singleton({ kind }) {
  // kind: 'settings' | 'seo'
  const qc = useQueryClient();
  const endpoint = kind === "seo" ? "/seo" : "/settings";
  const putEndpoint = kind === "seo" ? "/admin/seo" : "/admin/settings";
  const label = kind === "seo" ? "SEO Settings" : "Site Settings";

  const { data } = useQuery({ queryKey: [kind === "seo" ? "seo" : "settings"], queryFn: async () => (await api.get(endpoint)).data });
  const [form, setForm] = useState(null);
  useEffect(() => { if (data && !form) setForm(data); }, [data]); // eslint-disable-line

  const save = useMutation({
    mutationFn: async (payload) => (await api.put(putEndpoint, payload)).data,
    onSuccess: () => { qc.invalidateQueries(); toast.success("Tersimpan"); },
    onError: (e) => toast.error(formatError(e.response?.data?.detail)),
  });

  if (!form) return <p className="overline text-xs text-muted-foreground">Memuat…</p>;
  const keys = Object.keys(form).filter((k) => !HIDDEN_FIELDS.includes(k) && k !== "_id");
  const setField = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div data-testid={`singleton-${kind}`}>
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="font-display font-black tracking-tightest text-3xl md:text-4xl">{label}</h1>
        <button onClick={() => save.mutate(form)} disabled={save.isPending} className="btn-primary rounded-full px-6 py-3 overline text-[10px] disabled:opacity-50" data-testid="singleton-save">{save.isPending ? "Menyimpan…" : "Simpan"}</button>
      </div>
      <div className="grid md:grid-cols-2 gap-5 max-w-4xl">
        {keys.map((k) => <FieldEditor key={k} fieldKey={k} value={form[k]} onChange={setField(k)} />)}
      </div>
    </div>
  );
}
